<template>
  <div>
    <div class="main">
      <h2 class="title">商品列表</h2>
      <goods-slot v-for="item of list" :key="item.id" :list="item"></goods-slot>
    </div>
  </div>
</template>

<script>
import GoodsSlot from './slot/goodsSlot'
export default {
  data () {
    return {
      list: [
        {
          img: "../../../../static/images/mall01.jpg",
          id: "001",
          title: "微信公众号开发",
          info: "微信公众号开发，从项目需求分析、公众号界面设计、前端界面实现、后台功能开发测试上线一条龙服务，保证项目正常上线运行，您想要的产品、我们帮您定制！",
          price: "20000",
          bgColor: {active: false}
        },
        {
          img: "../../../../static/images/mall02.jpg",
          id: "002",
          title: "小程序开发",
          info: "微信公众号开发，从项目需求分析、公众号界面设计、前端界面实现、后台功能开发测试上线一条龙服务，保证项目正常上线运行，您想要的产品、我们帮您定制！",
          price: "20000",
          bgColor: {active: true}
        },
        {
          img: "../../../../static/images/mall03.jpg",
          id: "003",
          title: "网站开发",
          info: "微信公众号开发，从项目需求分析、公众号界面设计、前端界面实现、后台功能开发测试上线一条龙服务，保证项目正常上线运行，您想要的产品、我们帮您定制！",
          price: "20000",
          bgColor: {active: false}
        },
        {
          img: "../../../../static/images/mall04.jpg",
          id: "004",
          title: "微信代运营",
          info: "微信公众号开发，从项目需求分析、公众号界面设计、前端界面实现、后台功能开发测试上线一条龙服务，保证项目正常上线运行，您想要的产品、我们帮您定制！",
          price: "50000",
          bgColor: {active: true}
        }
      ]
    }
  },
  components: {
    GoodsSlot
  }
}
</script>

<style scoped>
.main {
  background-color: #f3f3f3;
  padding-bottom: 190px;
}
.title {
  font-size: 42px;
  text-align: center;
  line-height: 164px;
  background-color: #fff;
  transition: all .6s ease;
}
@media (max-width: 1199px) {
  .main {
    padding-bottom: 100px;
  }
  .title {
    font-size: 32px;
    line-height: 132px;
  }
}
@media screen and (max-width: 801px){
   .title {
    font-size: 26px;
    line-height: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mall/goods.vue